const views: Array<{
  id: number;
  path: string;
  title: string;
  img: string;
  view: string;
  component: string;
}> = [
  {
    id: 1,
    title: "Pfade",
    path: "/graphs/path",
    img: "weight.png",
    view: "SimplePath",
    component: "SimplePath",
  },
  {
    id: 2,
    title: "Rundwege",
    path: "/graphs/roundtrip",
    img: "weight.png",
    view: "Roundtrip",
    component: "Roundtrip",
  },
  {
    id: 3,
    title: "Verschiedene Pfade",
    path: "/graphs/multipath",
    img: "weight.png",
    view: "MultiPath",
    component: "MultiPath",
  },
  {
    id: 4,
    title: "Pilze sammeln",
    path: "/graphs/mushrooms",
    img: "weight.png",
    view: "CollectMushrooms",
    component: "CollectMushrooms",
  },
  {
    id: 5,
    title: "Schnellste Pfade",
    path: "/graphs/weights",
    img: "weight.png",
    view: "WeightsPath",
    component: "WeightsPath",
  },
  {
    id: 6,
    title: "Pilze auf Zeit",
    path: "/graphs/timed",
    img: "weight.png",
    view: "TimedMushrooms",
    component: "TimedMushrooms",
  },


];

export default views;
